import { render, staticRenderFns } from "./ListadoEventosImagen.vue?vue&type=template&id=4c1f5c99&scoped=true"
import script from "./ListadoEventosImagen.vue?vue&type=script&lang=js"
export * from "./ListadoEventosImagen.vue?vue&type=script&lang=js"
import style0 from "./ListadoEventosImagen.vue?vue&type=style&index=0&id=4c1f5c99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f5c99",
  null
  
)

export default component.exports